<template>
  <b-modal
    :id="modalId"
    ref="modal"
    :title="isTeacher ? 'Envoyer un message' : 'Message à tous'"
    @show="resetForm"
    :hide-footer="isStudent"
    scrollable
  >
    <template v-if="isTeacher">
      <b-form @submit.stop.prevent="onSubmit">
        <b-form-group
          label="Envoyer un message à tous les participants"
          label-for="shortcut-input"
        >
          <b-form-textarea
            placeholder="Saississez un message..."
            rows="4"
            max-rows="6"
            no-resize
            v-model="form.message"
          ></b-form-textarea>
        </b-form-group>
      </b-form>
    </template>
    <template v-if="isStudent">
      <UnitGeneralMessage />
    </template>
    <template v-slot:modal-footer="{ ok, close }">
      <b-btn pill variant="outline-secondary" @click="close()">Annulé</b-btn>
      <b-btn
        pill
        @click="onSubmit(ok)"
        variant="primary"
        :disabled="callStatus == 'fetching'"
      >
        <span>Ajouter</span>
        <b-spinner
          class="ml-2"
          small
          v-if="callStatus == 'fetching'"
        ></b-spinner
      ></b-btn>
    </template>
  </b-modal>
</template>

<script>
/**
 * @file       General comment message modal component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { mapState } from "vuex";
import { commentsMixin } from "@/modules/comments/mixins";
import UnitGeneralMessage from "@/modules/comments/components/unitGeneralMessage.vue";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "generalMessageModal",
  mixins: [commentsMixin],
  components: { UnitGeneralMessage },

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      modalId: "generalMessageModal",
      form: {
        message: ""
      }
    };
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      callStatus: state => state.comments.message.status
    })
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Called on submit.
     * 
     * @param  {Function}   ok    The action
     */
    onSubmit(ok) {
      if (this.form.message) {
        this.$store
          .dispatch("comments/postGeneralMessage", {
            teacher: this.profile.id,
            message: this.form.message,
            deliberation: this.dlibr.id
          })
          .then(() => {
            this.$root.$bvToast.toast(`Votre message a été envoyé`, {
              title: "Succès"
            });
            ok();
          });
      }
    },
    /**
     * Resets the form.
     */
    resetForm() {
      this.form = {
        message: ""
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>
